export default function filterOptions(query, options) {
  const q = (query || "").trim().toLowerCase();

  if (!q) return options; // ✅ show all when no query

  return options.filter((o) => {
    const searchable = `${o.id} ${o.name || ""} ${o.org_code || ""} ${o.code || ""}`.toLowerCase();
    return searchable.includes(q);
  });
}